export const minLengthValidatorFactory =
  (minLength: number) => (value: string) =>
      (value !== null && value !== undefined)
?
   ( (value.length >= minLength || value === "" )
      ? ""
      : `Errore, il campo deve avere almeno ${minLength} caratteri`)
          : "";
